import { useDispatch, useSelector } from "react-redux";
import { CustomButton } from "../../../../core/components/CustomButton";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { AppDispatch, RootState } from "../../../../core/store/store";
import { DeleteCurrentPartnerParams } from "../../domain/usecases/deleteCurrentPartner";
import { onCancelCurrentInvitation, onDeleteCurrentPartner, onResponseInvitation } from "../store/PartnerThunk";
import { deletePartner, setPartner } from "../../../profile/presentation/store/OnboardingSlice";
import { CancelInvitationPartnerParams } from "../../domain/usecases/CancelInvitationPartner";
import { deleteAllPartnerFromList, deletePartnerFromList, setErrorPartnerResponse } from "../store/PartnerSlice";
import { ResponseInvitationParams } from "../../domain/usecases/responseInvitation";
import { PartnerPending, PartnerPicture } from "../../domain/entities/partnerPending";
import { useEffect, useState } from "react";
import { ModalSimple } from "../../../../core/components/Modal";
import { CheckVerifyBG } from "../../../../core/icons/CheckVerifyBG";
import { AddPartnerComponent } from "./AddpartnerComponent";
import { WarningBG } from "../../../../core/icons/Warning";
import { Column } from "../../../../core/components/Column";
import { onGetUserInfoById } from "../../../match/presentation/store/MatchThunk";
import ProfilePreview from "../../../profile/presentation/components/ProfilePreview";
import { Likes } from "../../../match/domain/entities/userMatch";
import { getMatchLocationParams } from "../../../../core/utilities/locationStorage";
import { formatPublicProfileDistanceText } from "../../../../core/utilities/distance";

export const PartnerSettings = () => {
	const dispatch: AppDispatch = useDispatch();
	const { user, partner } = useSelector((state: RootState) => state.onboarding);
	const { partners, cancelLoading, deleteLoading, errorPartnerResponse } = useSelector((state: RootState) => state.partner);
	const [actionToConfirm, setActionToConfirm] = useState<(() => void) | null>(null);
	const [partnerModalOpen, setPartnerModalOpen] = useState(false);
	const [isModalPartnerOpen, setIsModalPartnerOpen] = useState<boolean>(false);
	const [modalMessage, setModalMessage] = useState("");
	const [isPartnerDelete, setIsPartnerDelete] = useState(false);
	const [infoErrorParter, setInfoErrorParter] = useState<{ title: string; name: string; description: string }>({
		title: "",
		name: "",
		description: "",
	});
	const handleCancelPending = async (cancelParams: CancelInvitationPartnerParams) => {
		if (cancelParams?.user_id) {
			const response = await dispatch(onCancelCurrentInvitation(cancelParams));
			if (response.meta.requestStatus === "fulfilled" || (response as any)?.error?.message === "404") dispatch(deletePartner());
		} else {
			console.error("Invalid cancel parameters");
		}
	};
	const [userInfoProfile, setUserInfoProfile] = useState<Likes | undefined>(undefined);
	const [openUserInfoProfile, setOpenUserInfoProfile] = useState(false);
	const [loadingUserInfo, setLoadingUserInfo] = useState(false);

	const handleDeletePartner = async (deletePartnerParams: DeleteCurrentPartnerParams) => {
		if (deletePartnerParams?.user_id) {
			const response = await dispatch(onDeleteCurrentPartner(deletePartnerParams));
			if (response.meta.requestStatus === "fulfilled" || (response as any)?.error?.message === "404") dispatch(deletePartner());
		} else {
			console.error("Invalid delete partner");
		}
	};

	const handleCancelResponse = (request: ResponseInvitationParams, deleteInvitation: PartnerPending, deletePartnerParams: DeleteCurrentPartnerParams) => {
		if (request?.user_id) {
			dispatch(onResponseInvitation(request));
			dispatch(onDeleteCurrentPartner(deletePartnerParams));
			// dispatch(deletePartner());

			dispatch(deletePartnerFromList(deleteInvitation));
		} else {
			console.error("Invalid request delete");
		}
	};

	useEffect(() => {
		switch (errorPartnerResponse) {
			case "ERROR_CREATING_PARTNER_RESPONSE":
				if (partner?.username) {
					setIsPartnerDelete(true);
					setInfoErrorParter({
						title: "This user removed you",
						name: partner?.username,
						description: "canceled the request to become a partner with you",
					});
					dispatch(deletePartner());
				}
				break;
			case "Error! You cannot invite the user":
				setIsPartnerDelete(true);
				setInfoErrorParter({
					title: "This user cannot be invited",
					name: "",
					description: "This user already has a partner",
				});
				break;
			default:
				break;
		}
	}, [dispatch, errorPartnerResponse, partner?.username]);

	const handleAccept = async (request: ResponseInvitationParams, acceptedPartner: PartnerPending) => {
		if (request?.user_id && user?.id) {
			dispatch(onResponseInvitation(request));
			dispatch(deletePartner());
			dispatch(deleteAllPartnerFromList());
			dispatch(
				setPartner({
					id: acceptedPartner.user_id,
					user_id1: acceptedPartner.user_id,
					profile_pictures: acceptedPartner.profile_pictures as PartnerPicture,
					user_id2: user.id,
					username: acceptedPartner.username,
					created_at: acceptedPartner.created_at,
					status: "accepted",
				})
			);
		} else {
			console.error("Invalid request data");
		}
	};

	const handleActionPartnerResponse = () => {
		dispatch(setErrorPartnerResponse(""));
		setInfoErrorParter({ title: "", description: "", name: "" });
		setIsPartnerDelete(false);
	};

	const confirmAction = (action: () => void, message: string) => {
		setActionToConfirm(() => action);
		setModalMessage(message);
		setPartnerModalOpen(true);
	};

	const handleCloseAddPartner = () => {
		setIsModalPartnerOpen(false);
	};

	const handleShowUserProfile = async (user_id: string) => {
		setLoadingUserInfo(true);
		setOpenUserInfoProfile(true);
		const result = await dispatch(
			onGetUserInfoById({
				params: {
					user_id: user_id || "",
					...getMatchLocationParams(),
				},
			})
		);
		setLoadingUserInfo(false);
		setUserInfoProfile(result.payload as Likes);
	};

	const PartnerCard = ({
		id,
		partnerName,
		status,
		picture,
		variant,
		onAccept,
		onCancel,
		loading,
	}: {
		id: string;
		partnerName: string;
		status: "pending" | "accepted";
		picture: string;
		variant: number;
		onAccept?: () => void;
		onCancel: () => void;
		loading?: boolean;
	}) => {
		return (
			<Row
				className="border p-4 rounded-lg justify-between gap-1"
				crossAxisAlignment="center"
				{...(variant === 1 && { responsiveCol: true })}
			>
				<Row
					className="gap-2 !w-fit hover:underline hover:decoration-primary cursor-pointer"
					onClick={() => handleShowUserProfile(id)}
					mainAxisAlignment="between"
					crossAxisAlignment="center"
				>
					<img
						className="w-10 md:w-12 aspect-square object-cover rounded-full"
						src={picture}
						draggable={false}
						alt={`profile-${partnerName}`}
					/>
					<Row className="gap-1">
						<TextComponent
							variant="h4"
							className="text-primary font-semibold break-all"
						>
							{partnerName || "Unknown User"}
						</TextComponent>
						{variant === 1 ? (
							<TextComponent
								variant="h4"
								className="font-semibold"
							>
								(requested)
							</TextComponent>
						) : (
							status === "pending" && (
								<TextComponent
									variant="h4"
									className="font-semibold"
								>
									(pending)
								</TextComponent>
							)
						)}
					</Row>
				</Row>
				<Row
					className="!w-fit gap-1 md:gap-2 self-end md:self-center"
					mainAxisAlignment="center"
					crossAxisAlignment="center"
				>
					{variant === 1 ? (
						<>
							<CustomButton
								small
								onClick={onAccept}
							>
								Accept
							</CustomButton>
							<CustomButton
								small
								onClick={onCancel}
							>
								Cancel
							</CustomButton>
						</>
					) : (
						<CustomButton
							className="h-fit"
							small
							onClick={onCancel}
							loading={loading}
						>
							{status === "pending" ? "Cancel" : "Delete"}
						</CustomButton>
					)}
				</Row>
			</Row>
		);
	};

	return (
		<>
			{openUserInfoProfile && (
				<div className="fixed top-0 left-0 z-40 h-screen w-full bg-[#0000006b]">
					<ProfilePreview
						pictures={userInfoProfile?.profile_pictures}
						username={userInfoProfile?.username}
						verify={userInfoProfile?.verify_status}
						bio={userInfoProfile?.bio}
						desires={userInfoProfile?.desires}
						interest={userInfoProfile?.interests}
						birth={userInfoProfile?.age}
						location={userInfoProfile?.city}
						last_logged_in_time={userInfoProfile?.last_logged_in_time}
						show_last_logged={userInfoProfile?.show_last_logged}
						sexual_orientation={userInfoProfile?.sexual_orientation}
						marital_status={userInfoProfile?.marital_status}
						country={userInfoProfile?.country || ""}
						gender={userInfoProfile?.gender}
						distance={formatPublicProfileDistanceText(userInfoProfile?.distance, {
							country: user?.country,
							city: user?.city,
						})}
						handleProfilePreview={() => {
							setOpenUserInfoProfile(false);
							setUserInfoProfile(undefined);
						}}
						partner={userInfoProfile?.partner}
						isBlur={false}
						loading={loadingUserInfo}
					/>
				</div>
			)}
			<TextComponent
				variant="h2"
				className="font-semibold mt-3 mb-3"
			>
				Partner
			</TextComponent>
			<Column className="gap-2">
				{partner === null || partner?.status === "rejected" ? (
					<div className="w-3/4">
						<CustomButton onClick={() => setIsModalPartnerOpen(true)}>Add Partner</CustomButton>
					</div>
				) : (
					<>
						{partner && (
							<>
								<Row
									className="gap-2 lg:gap-4"
									crossAxisAlignment="center"
								>
									<TextComponent
										variant="h5"
										className="text-graySecondary w-fit"
									>
										{partner.status === "pending" ? "Pending Partner Invitation" : "Connected with"}
									</TextComponent>
									<hr className="border-grayLight2 flex-grow" />
								</Row>
								<PartnerCard
									variant={2}
									id={partner.user_id || partner.user_id1}
									partnerName={partner.username}
									picture={Array.isArray(partner.profile_pictures) ? partner.profile_pictures[0] : partner.profile_pictures?.url ?? ""}
									status={partner.status as "pending" | "accepted"}
									onCancel={() => {
										if (partner.status === "pending") {
											confirmAction(
												() => handleCancelPending({ user_id: user?.id === partner.user_id1 ? partner.user_id2 : partner.user_id1 }),
												`Are you sure you want to cancel the invitation to ${partner.username}?`
											);
										} else if (partner.status === "accepted") {
											confirmAction(
												() => handleDeletePartner({ user_id: user?.id === partner.user_id1 ? partner.user_id2 : partner.user_id1 }),
												`Are you sure you want to delete ${partner.username}?`
											);
										}
									}}
									loading={partner.status === "pending" ? cancelLoading : deleteLoading}
								/>
							</>
						)}
					</>
				)}
				{partners.length > 0 && (
					<>
						<Row
							className="gap-2 lg:gap-4"
							crossAxisAlignment="center"
						>
							<TextComponent
								variant="h5"
								className="text-graySecondary w-fit"
							>
								New Partner Invitations
							</TextComponent>
							<hr className="border-grayLight2 flex-grow" />
						</Row>
						{partners.map((partner) => (
							<PartnerCard
								key={partner.user_id}
								id={partner.user_id}
								variant={1}
								partnerName={partner.username || "Unknown User"}
								picture={Array.isArray(partner.profile_pictures) ? partner.profile_pictures[0] : partner.profile_pictures?.url ?? ""}
								status="pending"
								onAccept={() =>
									confirmAction(() => handleAccept({ user_id: partner.user_id, partner_response: true }, partner), `Are you sure you want to accept ${partner.username}?`)
								}
								onCancel={() =>
									confirmAction(
										() => handleCancelResponse({ user_id: partner.user_id, partner_response: false }, partner, { user_id: partner.user_id }),
										`Are you sure you want to cancel the invitation from ${partner.username}?`
									)
								}
							/>
						))}
					</>
				)}
			</Column>
			{isModalPartnerOpen && (
				<AddPartnerComponent
					isOpen={isModalPartnerOpen}
					onRequestClose={handleCloseAddPartner}
				/>
			)}

			<ModalSimple
				title="Confirm Action"
				variant="secondary"
				actionExecuted={partnerModalOpen}
				onClose={() => {
					setPartnerModalOpen(false);
				}}
				icon={<CheckVerifyBG />}
				enableButton={false}
			>
				<TextComponent variant="h5">{modalMessage}</TextComponent>
				<Row className="sticky bg-white pt-5 border border-transparent bottom-0 gap-4">
					<CustomButton
						onClick={() => {
							if (actionToConfirm) {
								actionToConfirm();
								setPartnerModalOpen(false);
							}
						}}
						className="w-1/2"
						small
					>
						Yes
					</CustomButton>
					<CustomButton
						onClick={() => setPartnerModalOpen(false)}
						className="w-1/2 text-primary"
						color="white"
						small
					>
						No
					</CustomButton>
				</Row>
			</ModalSimple>

			<ModalSimple
				title={infoErrorParter.title}
				variant="secondary"
				actionExecuted={isPartnerDelete}
				onClose={handleActionPartnerResponse}
				onAction={handleActionPartnerResponse}
				icon={<WarningBG />}
				enableButton={true}
				next
			>
				<TextComponent variant="h5">
					<span className="text-primary font-bold">{infoErrorParter.name}</span> {infoErrorParter.description}
				</TextComponent>
			</ModalSimple>
		</>
	);
};
